module.exports = __webpack_public_path__ + "static/img/2.dd36cba.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/4/2.png
// module id = 241
// module chunks = 0